import { SECTORS } from "../../constants/api";
import ApiService from "../../pages/broker/api/api-service";

export const getSectors = async () => {
	const response = await ApiService.get_sector(`${SECTORS}`);
	if (response) {
		return response;
	} else {
		return false;
	}
};
